import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import Modal from "react-responsive-modal"
import fieldStatus from "helpers/fieldStatus"
import submitData from "helpers/submitData"
import { Formik, Field, Form } from "formik"
import fields from "models/editUser"
import TextArea from "components/TextArea"
import * as Yup from "yup"
import ReactSelect from "components/ReactSelect"
import nulltoEmptyString from "helpers/nullToEmptyString"
import clone from "clone"
import { toast } from "react-toastify"
import NumberFormat from "react-number-format"
import _ from "lodash"

class EditSalespersonModal extends Component {
	constructor(props) {
		super(props)
		this.state = {
			ready: false,
			fields: clone(fields),
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.data !== this.props.data) {
			let data = clone(this.props.data)

			data = nulltoEmptyString(data)
			this.setState({
				fields: {
					first: data.first,
					last: data.last,
					email: data.email,
					level: data.level,
					properties: data.properties,
					builders: data.builders,
					neighborhoods: data.neighborhoods,
					status: data.status,
					office: data.office,
					cell: data.cell,
					notes: data.notes,
					lot_types: data.lot_types,
					builder_portal: data.builder_portal,
					disable_reminders: data.disable_reminders,
				},
				ready: true,
			})
		}
		return null
	}

	checkAll = (f, status, type) => {
		let vals = []
		if (type === "lot_types") {
			let opts = this.options(f, "lot_types")

			if (status) {
				opts.forEach((v) => {
					vals.push(v.value)
				})
			} else vals = []
		} else if (type === "neighborhoods") {
			let opts = this.options(f, "neighborhoods")
			if (status) {
				opts.forEach((v) => {
					vals.push(v.value)
				})
			} else vals = []
		}
		f.setFieldValue(type, vals)
	}

	validation = () => {
		return Yup.object().shape({
			first: Yup.string().min(2, "Must be longer than 2 characters").required("Required"),
			last: Yup.string().min(2, "Must be longer than 2 characters").required("Required"),
			email: Yup.string().email("Invalid email address").required("Required"),
			properties: Yup.array().min(1, "Please select at least one property.").required("Required"),
			neighborhoods: Yup.array().min(1, "Please select at least one neighborhood.").required("Required"),
			builders: Yup.array().min(1, "Please select at least one property.").required("Required"),
			status: Yup.number().required("Required"),
			office: Yup.string()
				.min(10, "Phone number must be 10 digits")
				.max(10, "Phone number must be 10 digits")
				.notRequired(),
			cell: Yup.string()
				.min(10, "Phone number must be 10 digits")
				.max(10, "Phone number must be 10 digits")
				.notRequired(),
		})
	}

	submitClasses = (f) => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}

	options = (f, name) => {
		let ret = []
		this.props.payload.public[name].forEach((v) => {
			if (f.values.properties && f.values.properties.includes(v.property)) {
				if (name == "lot_types") {
					let property = _.find(this.props.payload.public.properties, { id: v.property })
					let pname = property ? property.name : ""
					ret.push({ label: `${v.name} - ${pname}`, value: v.id })
				} else ret.push({ label: v.name, value: v.id })
			}
		})

		return ret
	}

	render() {
		if (this.props.payloadStatus) {
			const { open } = this.props
			return (
				<div>
					<Modal open={open} onClose={this.props.onClose} center>
						<h3>Edit {`${this.props.data.first} ${this.props.data.last}`}</h3>
						<Formik
							enableReinitialize
							initialValues={this.state.fields}
							validationSchema={this.validation}
							//validateOnMount={true}
							onSubmit={(values) => {
								this.props.loadingStatus(true)
								values.id = this.props.data.id
								submitData("editSalesperson", values).then((data) => {
									this.props.loadingStatus(false)
									toast.success(data.message)
									this.props.close()
									this.setState(
										{
											redirect: true,
											redirectPath: data.redirect,
										},
										() => {
											this.props.getPayload()
										}
									)
								})
							}}
							render={(f) => (
								<div className="editUser">
									<div className="content">
										<Form>
											{/* console.log(f) */}
											<ul className="form__list">
												<li className={fieldStatus("first", f)}>
													<label htmlFor="first">First Name *</label>
													{f.errors.first && f.touched.first && (
														<div className="form__message">{f.errors.first}</div>
													)}
													<Field name="first" type="text" className="form__input" />
												</li>
												<li className={fieldStatus("last", f)}>
													<label htmlFor="last">Last Name *</label>
													{f.errors.last && f.touched.last && (
														<div className="form__message">{f.errors.last}</div>
													)}
													<Field name="last" type="text" className="form__input" />
												</li>
												<li className={fieldStatus("email", f)}>
													<label htmlFor="email">Email *</label>
													{f.errors.email && f.touched.email && (
														<div className="form__message">{f.errors.email}</div>
													)}
													<Field name="email" type="email" className="form__input" />
												</li>
												<li className={fieldStatus("status", f)}>
													<label htmlFor="status">
														Status <sup>*</sup>
													</label>
													{f.errors.status && f.touched.status && (
														<div className="form__message">{f.errors.status}</div>
													)}
													<ReactSelect
														name={`status`}
														options={[
															{ value: 0, label: "Disabled" },
															{ value: 1, label: "Enabled" },
														]}
														value={f.values.status}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
												<li className={fieldStatus("builder_portal", f)}>
													<label htmlFor="builder_portal">Builder Portal Access</label>
													{f.errors.builder_portal && f.touched.builder_portal && (
														<div className="form__message">{f.errors.builder_portal}</div>
													)}
													<ReactSelect
														name={`builder_portal`}
														options={[
															{ value: 1, label: "Yes" },
															{ value: 0, label: "No" },
														]}
														value={f.values.builder_portal}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
												<li className={fieldStatus("disable_reminders", f)}>
													<label htmlFor="disable_reminders">Disable Reminders?</label>
													{f.errors.disable_reminders && f.touched.disable_reminders && (
														<div className="form__message">{f.errors.disable_reminders}</div>
													)}
													<ReactSelect
														name={`disable_reminders`}
														options={[
															{ value: 1, label: "Yes" },
															{ value: 0, label: "No" },
														]}
														value={f.values.disable_reminders}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
												<li className={fieldStatus("properties", f, false, false, true)}>
													<label htmlFor="properties">
														Properties <sup>*</sup>
													</label>
													{f.errors.properties && f.touched.properties && (
														<div className="form__message">{f.errors.properties}</div>
													)}
													<ReactSelect
														name={`properties`}
														options={_.map(this.props.payload.public.properties, (v) => {
															return { label: v.name, value: v.id }
														})}
														isMulti
														value={f.values.properties}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
												<li className={fieldStatus("builders", f, false, false, true)}>
													<label htmlFor="builders">
														Builders <sup>*</sup>
													</label>
													{f.errors.builders && f.touched.builders && (
														<div className="form__message">{f.errors.builders}</div>
													)}
													<ReactSelect
														name={`builders`}
														options={_.map(this.props.payload.public.builders, (v) => {
															return {
																label: v.name,
																value: v.id,
															}
														})}
														isMulti
														value={f.values.builders}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
												<li className={fieldStatus("neighborhoods", f, false, false, true)}>
													<label htmlFor="neighborhoods">
														Neighborhoods <sup>*</sup>
													</label>
													{f.errors.neighborhoods && f.touched.neighborhoods && (
														<div className="form__message">{f.errors.neighborhoods}</div>
													)}
													<p className="filterCheck">
														<span onClick={() => this.checkAll(f, true, "neighborhoods")}>
															Check All
														</span>
														<span onClick={() => this.checkAll(f, false, "neighborhoods")}>
															Uncheck All
														</span>
													</p>
													<ReactSelect
														name={`neighborhoods`}
														options={this.options(f, "neighborhoods")}
														isMulti
														value={f.values.neighborhoods}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
												<li className={fieldStatus("lot_types", f, false, false, true)}>
													<label htmlFor="lot_types">
														Lot Types <sup>*</sup>
													</label>
													{f.errors.lot_types && f.touched.lot_types && (
														<div className="form__message">{f.errors.lot_types}</div>
													)}
													<p className="filterCheck">
														<span onClick={() => this.checkAll(f, true, "lot_types")}>
															Check All
														</span>
														<span onClick={() => this.checkAll(f, false, "lot_types")}>
															Uncheck All
														</span>
													</p>
													<ReactSelect
														name={`lot_types`}
														options={this.options(f, "lot_types")}
														isMulti
														value={f.values.lot_types}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
												<li className={fieldStatus("office", f, false, false, true)}>
													<label htmlFor="office">Office Phone</label>
													{f.errors.office && f.touched.office && (
														<div className="form__message">{f.errors.office}</div>
													)}
													<NumberFormat
														name="office"
														format="+1 (###) ###-####"
														className="form__input"
														isNumericString
														value={f.values.office}
														onValueChange={(v) => f.setFieldValue("office", v.value)}
														onBlur={() => f.setFieldTouched("office", true)}
													/>
												</li>
												<li className={fieldStatus("cell", f, false, false, true)}>
													<label htmlFor="cell">Cell Phone</label>
													{f.errors.cell && f.touched.cell && (
														<div className="form__message">{f.errors.cell}</div>
													)}
													<NumberFormat
														name="cell"
														format="+1 (###) ###-####"
														className="form__input"
														value={f.values.cell}
														isNumericString
														onValueChange={(v) => f.setFieldValue("cell", v.value)}
														onBlur={() => f.setFieldTouched("cell", true)}
													/>
												</li>
												<li className={fieldStatus("notes", f, false, false, true)}>
													<label htmlFor="notes">Notes</label>
													{f.errors.notes && f.touched.notes && (
														<div className="form__message">{f.errors.notes}</div>
													)}
													<TextArea
														name="notes"
														className="form__textarea"
														value={f.values.notes}
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched.notes}
														error={f.errors.notes}
													/>
												</li>
											</ul>
											<input
												type="submit"
												value="Submit"
												className={this.submitClasses(f.isValid)}
											/>
										</Form>
									</div>
								</div>
							)}
						/>
					</Modal>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getPayload,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(EditSalespersonModal)
